module.exports = __webpack_public_path__ + "img/m-gongzi.ed35d54e.svg";